import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useMemo } from 'react';
import Loadable from 'react-loadable';
import { CARDS_EXTENSION_TYPE } from '@atlassian/cards-extension/constants';
import { carouselExtensionType } from '@atlassian/carousel-extension';
import { ExtensionMode, SECTION_EXTENSION_TYPE, SPOTLIGHT_EXTENSION_TYPE } from '@atlassian/company-hub-common';
import { LINKS_MENU_EXTENSION_TYPE } from '@atlassian/links-menu-extension';
var SpotlightExtensionLoader = Loadable({
  loader: function () {
    var _loader = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return import( /* webpackChunkName: "@atlaskit-internal_spotlight-extension" */'@atlassian/spotlight-extension');
          case 2:
            return _context.abrupt("return", _context.sent.SpotlightExtension);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function loader() {
      return _loader.apply(this, arguments);
    }
    return loader;
  }(),
  loading: function loading() {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
});
var LinksMenuLoader = Loadable({
  loader: function () {
    var _loader2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return import( /* webpackChunkName: "@atlaskit-internal_links-menu-extension" */'@atlassian/links-menu-extension');
          case 2:
            return _context2.abrupt("return", _context2.sent.LinksMenu);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function loader() {
      return _loader2.apply(this, arguments);
    }
    return loader;
  }(),
  loading: function loading() {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
});
export var CardsExtensionLoader = Loadable({
  loader: function () {
    var _loader3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return import( /* webpackChunkName: "@atlaskit-internal_cards-extension" */'@atlassian/cards-extension');
          case 2:
            return _context3.abrupt("return", _context3.sent.CardsExtension);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function loader() {
      return _loader3.apply(this, arguments);
    }
    return loader;
  }(),
  loading: function loading() {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
});
var CarouselLoader = Loadable({
  loader: function () {
    var _loader4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return import( /* webpackChunkName: "@atlaskit-internal_carousel-extension" */'@atlassian/carousel-extension');
          case 2:
            return _context4.abrupt("return", _context4.sent.Carousel);
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function loader() {
      return _loader4.apply(this, arguments);
    }
    return loader;
  }(),
  loading: function loading() {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
});
var SectionExtensionLoader = Loadable({
  loader: function () {
    var _loader5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return import( /* webpackChunkName: "@atlaskit-internal_section-extension" */'@atlassian/section-extension');
          case 2:
            return _context5.abrupt("return", _context5.sent.SectionExtension);
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    function loader() {
      return _loader5.apply(this, arguments);
    }
    return loader;
  }(),
  loading: function loading() {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
});
export var useHubExtensionHandlers = function useHubExtensionHandlers(props) {
  var contentId = props.contentId,
    PropsProvider = props.PropsProvider;
  var extensionHandlers = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SPOTLIGHT_EXTENSION_TYPE, function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }), LINKS_MENU_EXTENSION_TYPE, function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }), CARDS_EXTENSION_TYPE, function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }), carouselExtensionType, function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }), SECTION_EXTENSION_TYPE, function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  });
  var defaultExtensionHandlerProps = useMemo(function () {
    return {
      contentId: contentId,
      propsProvider: PropsProvider,
      mode: ExtensionMode.RENDERER
    };
  }, [contentId, PropsProvider]);
  var spotlightExtension = useCallback(function (extension) {
    return /*#__PURE__*/React.createElement(SpotlightExtensionLoader, _extends({}, defaultExtensionHandlerProps, {
      extensionNode: extension
    }));
  }, [defaultExtensionHandlerProps]);
  var linksMenuExtension = useCallback(function (extension) {
    return /*#__PURE__*/React.createElement(LinksMenuLoader, _extends({}, defaultExtensionHandlerProps, {
      extensionNode: extension
    }));
  }, [defaultExtensionHandlerProps]);
  var cardsExtension = useCallback(function (extension) {
    return /*#__PURE__*/React.createElement(CardsExtensionLoader, _extends({}, defaultExtensionHandlerProps, {
      extensionNode: extension
    }));
  }, [defaultExtensionHandlerProps]);
  var carouselExtension = useCallback(function (extension) {
    return /*#__PURE__*/React.createElement(CarouselLoader, _extends({}, defaultExtensionHandlerProps, {
      extensionNode: extension
    }));
  }, [defaultExtensionHandlerProps]);
  var sectionExtension = useCallback(function (extension) {
    return /*#__PURE__*/React.createElement(SectionExtensionLoader, _extends({}, defaultExtensionHandlerProps, {
      extensionNode: extension
    }));
  }, [defaultExtensionHandlerProps]);
  if (contentId) {
    extensionHandlers[SPOTLIGHT_EXTENSION_TYPE] = spotlightExtension;
    extensionHandlers[LINKS_MENU_EXTENSION_TYPE] = linksMenuExtension;
    extensionHandlers[CARDS_EXTENSION_TYPE] = cardsExtension;
    extensionHandlers[carouselExtensionType] = carouselExtension;
    extensionHandlers[SECTION_EXTENSION_TYPE] = sectionExtension;
  }
  return extensionHandlers;
};